import React from 'react';
import Wrapper from '../../ui/Wrapper';
import { ComboModalCont, ComboModalTop } from './styles';
import { CombosItemContainer } from '../../features/Combos/CombosItem/styled';
import { getComboItems } from '../../features/Combos/helper';
import { hideModal as HideModal } from './../../actions/UiActions';
import { connect } from 'react-redux';
import CloseButton from '../../components/CloseButton/CloseButton';
import Text from '../../ui/Text';
import { SYSTEM_NAMES_WEB } from '../../constants/appConfig';
import CombosButton from '../../features/Combos/ComboButton/ComboButton';
import { detectMobile } from '../../utils/UiHelper';

const ComboDescriptionModal = ({ modalData, betslip, hideModal }) => {
    const items = [0, 1, 2, 3, 4, 5];

    return (
        <Wrapper
            height={'100%'}
            width={'100%'}
            flex
            flexDirection={'column'}
            flexAlign={'center'}
            justify={detectMobile() ? 'flex-end' : 'center'}
            padding={detectMobile() ? '0 0 100px' : '0'}
            margin={'0'}
            boxSizing={'border-box'}
            zIndex={3}
            overflow={'hidden'}
        >
            <ComboModalCont>
                <ComboModalTop>
                    <Text
                        size={'16'}
                        lh={'24'}
                        color={'#1E1E1E'}
                        margin={'0'}
                        bold
                        align={'center'}
                        padding={'16px 30px'}
                    >
                        {
                            SYSTEM_NAMES_WEB[
                                modalData.markets.betItems.length - 1
                            ]
                        }
                    </Text>
                    <CloseButton
                        bC={'transparent'}
                        iconColor={'#BFC9D9'}
                        click={() => hideModal('COMBO_DESCRIPTION_MODAL')}
                        right={'15px'}
                    />
                </ComboModalTop>
                <Wrapper
                    width={'100%'}
                    boxSizing={'border-box'}
                    padding={'0 16px'}
                    margin={'0'}
                >
                    <CombosItemContainer isModal>
                        {getComboItems(
                            modalData.markets,
                            true,
                            betslip.setMarketsNew
                        )}
                    </CombosItemContainer>
                </Wrapper>
                <Wrapper padding={'16px'}>
                    <CombosButton
                        position={modalData.position}
                        userId={modalData.userId}
                        markets={modalData.markets}
                        isModal
                        closeModalHandler={() =>
                            hideModal('COMBO_DESCRIPTION_MODAL')
                        }
                    />
                </Wrapper>
            </ComboModalCont>
        </Wrapper>
    );
};

function mapStateToProps(state) {
    return { betslip: state.betslip };
}

const mapDispatchToProps = (dispatch) => {
    return {
        hideModal: (modalId) => dispatch(HideModal(modalId)),
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ComboDescriptionModal);
